import config from '@/config'
import { LogLevel, LoggerEnvironment } from './logger.constants'
import type { Metadata, Transport } from './logger.types'
import { consoleTransport } from './transports/console'
import { sentryTransport } from './transports/sentry'

export class Logger {
	transports: Transport[] = []

	debug(message: string, metadata: Metadata = {}) {
		this.logToTransports(LogLevel.Debug, message, metadata)
	}

	info(message: string, metadata: Metadata = {}) {
		this.logToTransports(LogLevel.Info, message, metadata)
	}

	warn(message: string, metadata: Metadata = {}) {
		this.logToTransports(LogLevel.Warn, message, metadata)
	}

	error(message: string | Error, metadata: Metadata = {}) {
		this.logToTransports(LogLevel.Error, message, metadata)
	}

	addTransport(transport: Transport) {
		this.transports.push(transport)

		return () => {
			this.transports.splice(this.transports.indexOf(transport), 1)
		}
	}

	logToTransports(level: LogLevel, message: string | Error, metadata: Metadata = {}) {
		const timestamp = Date.now()

		for (const transport of this.transports) {
			transport(level, message, metadata, timestamp)
		}
	}
}

export const logger = new Logger()

if (config.LOGGER_ENVIRONMENT === LoggerEnvironment.Dev) {
	logger.addTransport(consoleTransport)
}

if (
	config.LOGGER_ENVIRONMENT === LoggerEnvironment.Stage ||
	config.LOGGER_ENVIRONMENT === LoggerEnvironment.Prod
) {
	logger.addTransport(sentryTransport)
}
